import { ReactElement } from 'react';

import { BindingCreator } from '@dreryk/react-common';
import { appendTestableComponentAttributes, Heading, PostcodeInput, StyledFlex } from '@dreryk/react-components';

import { prescriptionsTranslationKeys } from '../../../../../../../../translations';

import { StyledAddressSection } from './AddressSection.styled';
import { ProAuctoreAndProFamiliaAddressSectionFormBeanPart } from './AddressSection.types';
import { BuildingField } from './fields/BuildingField';
import { FlatField } from './fields/FlatField';
import { StreetField } from './fields/StreetField';
import { TownField } from './fields/TownField';

type AddressSectionProps = {
   readonly register: BindingCreator<ProAuctoreAndProFamiliaAddressSectionFormBeanPart>;
};

export const AddressSection = (props: AddressSectionProps): ReactElement => {
   return (
      <StyledFlex
         direction={'column'}
         {...appendTestableComponentAttributes(
            'PractitionerMissingAddressSection',
            'practitionerMissingAddressSection'
         )}
      >
         <Heading
            content={prescriptionsTranslationKeys.missingAddressForPAPF.yourAddress}
            testId={'yourAddress'}
            type={'h2'}
         />
         <StyledAddressSection>
            <StreetField register={props.register} />
            <BuildingField register={props.register} />
            <FlatField register={props.register} />
            <TownField register={props.register} />
            <PostcodeInput testId={'postcode'} controller={props.register('postcode', { required: true })} />
         </StyledAddressSection>
      </StyledFlex>
   );
};
